import React from 'react';
import ManagerDiscountRow from './ManagerDiscountRow';

const ManagerDiscount = ({
  onChange,
  nrcDiscountTotal,
  nrcDiscountPercent,
  rcDiscountPercent,
  rcDiscountTotal,
  isQuoteDiscountTypeManager,
  disabledState,
  lockedState,
}) => {
  const onChangeNrcDiscount = value => {
    onChange(value, 'oneTimeManagerDiscountPercentage');
  };

  const onChangeRcDiscount = value => {
    onChange(value, 'recurringManagerDiscountPercentage');
  };

  return (
    <>
      <ManagerDiscountRow
        id="manager_discount_nrc"
        label="msg_manager_discount_nrc"
        value={nrcDiscountPercent}
        onChange={onChangeNrcDiscount}
        discountTotal={nrcDiscountTotal}
        isQuoteDiscountTypeManager={isQuoteDiscountTypeManager}
        disabledState={disabledState}
        lockedState={lockedState}
      />
      <ManagerDiscountRow
        id="manager_discount_rc"
        label="msg_manager_discount_rc"
        value={rcDiscountPercent}
        onChange={onChangeRcDiscount}
        discountTotal={rcDiscountTotal}
        isQuoteDiscountTypeManager={isQuoteDiscountTypeManager}
        disabledState={disabledState}
        lockedState={lockedState}
      />
    </>
  );
};

export default ManagerDiscount;
